import { movies } from "@/mocks/movies";
import { tvs } from "@/mocks/tvs";
import type { MediaType, Movie, TvShow } from "@/types/media";

export interface MediaSummary {
  id: string;
  type: MediaType;
  title: string;
  year: number;
  country: string;
  director: string;
  actors: string[];
  genres: string[];
  rating: number;
  poster: string;
  description: string;
  updatedAt: string;
}

export function getMovieById(id: string): Movie | undefined {
  return movies.find((item) => item.id === id);
}

export function getTvById(id: string): TvShow | undefined {
  return tvs.find((item) => item.id === id);
}

export function toSummary(item: Movie | TvShow, type: MediaType): MediaSummary {
  return {
    id: item.id,
    type,
    title: item.title,
    year: item.year,
    country: item.country,
    director: item.director,
    actors: item.actors,
    genres: item.genres,
    rating: item.rating,
    poster: item.poster,
    description: item.description,
    updatedAt: item.updatedAt,
  };
}

export function getAllSummaries(): MediaSummary[] {
  return [
    ...movies.map((item) => toSummary(item, "movie")),
    ...tvs.map((item) => toSummary(item, "tv")),
  ];
}

export function getDetailRoute(type: MediaType, id: string): string {
  return type === "movie" ? `/detail/movie/${id}` : `/detail/tv/${id}`;
}

export function getTypeLabel(type: MediaType): string {
  return type === "movie" ? "电影" : "电视剧";
}

export function getGenreRoute(type: MediaType, genre: string): string {
  return `/category/${type}?genre=${encodeURIComponent(genre)}`;
}